import styled from 'styled-components';

export const ChartContainer = styled.div`
  width: 49%;
  background: #fff;
  // display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  // height: 450px;
`;

export const TableHeading = styled.span`
  font-size: 14px;
  color: rgb(52, 52, 52);
  font-weight: 600;
  font-family: 'Shell Font';
  line-height: 24px;
  letter-spacing: 0em;
  font-style: normal;
  text-align: left;
  fill: rgb(52, 52, 52);
  margin-bottom: 11px;
  margin-top: 4px;
`;

export const NcfToggle = styled.div`
  margin-top: 6px;
`;

export const ScrollableDiv = styled.div`
  overflow: auto;
  max-height: 383px;
`;

export const ChartFooterText = styled.span`
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: #757575;
`;
